import React from 'react';
import PropTypes from 'prop-types';
import {
  BtnsWrapper,
  ProgramCardWrapper,
  ProgramDiscp,
  ProgramImage,
  ProgramNumber,
  ProgramTag,
  ProgramTitle,
  RemoveBtn,
} from './ProgramCard.styles';
import Heart from 'Icons/Heart';
import { Link } from 'react-router-dom';
import Close from 'Icons/Close';

function ProgramCard({
  id,
  image,
  title,
  number,
  handleFav,
  handleHover,
  handleRemove,
  isFavorites,
  hasRemove,
}) {
  return (
    <ProgramCardWrapper onMouseEnter={handleHover}>
      <BtnsWrapper>
        <ProgramTag onClick={handleFav} isFav={isFavorites}>
          <Heart />
        </ProgramTag>
        {hasRemove && (
          <RemoveBtn onClick={() => handleRemove(id)}>
            <Close />
          </RemoveBtn>
        )}
      </BtnsWrapper>

      <Link to={`/poi/${id}`}>
        <ProgramImage src={image} />
        <ProgramDiscp>
          <ProgramNumber>{number}</ProgramNumber>
          {title && (
            <ProgramTitle level="h2" size="xl">
              {title}
            </ProgramTitle>
          )}
        </ProgramDiscp>
      </Link>
    </ProgramCardWrapper>
  );
}

ProgramCard.propTypes = {
  image: PropTypes.string.isRequired,
  title: PropTypes.string,
  number: PropTypes.number,
};

export default ProgramCard;
